import { fetchAvailableLocales } from "@/services/localeService";

let cachedSupportedLocales: Set<string> | null = null;
let loadingPromise: Promise<Set<string>> | null = null;

/**
 * Loads and caches the set of supported locale codes from the CMS /languages API.
 * Returns a Set of lowercased isoCode values (e.g., "en-us", "de-de", "it-it").
 */
export async function loadSupportedLocales(): Promise<Set<string>> {
  if (cachedSupportedLocales) {
    return cachedSupportedLocales;
  }

  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = (async (): Promise<Set<string>> => {
    try {
      const locales = await fetchAvailableLocales();

      cachedSupportedLocales = new Set(
        locales.map((entry) => entry.code.toLowerCase())
      );

      return cachedSupportedLocales;
    } catch (error) {
      console.error("Failed to load supported locales:", error);
      return new Set<string>();
    } finally {
      loadingPromise = null;
    }
  })();

  return loadingPromise;
}

export function getCachedSupportedLocales(): Set<string> | null {
  return cachedSupportedLocales;
}
